import Vue from 'vue'
import axios from 'axios'
import store from './store'

// const debug = process.env.NODE_ENV !== 'production'
// const root = 'http://api.192.168.99.100.nip.io/'
const root = '//api.youtv.com.ua/'
// const root = '//api.stage.youtv.com.ua/'
const timeout = 5 * 1000

export const login = credentials => postJson('isp/auth/login', credentials)
export const isp = () => get('isp/info')
export const user = () => get('isp/user/info')
export const refreshjwt = () => get('isp/auth/refresh')
export const orders = (from, to) => {
    if (from && to) {
        return get('isp/orders?from='+from+'&to='+to)
    } else {
        return get('isp/orders')
    }
}

var HTTP = axios.create({
  baseURL: root,
  timeout
})

function postJson(path, data) {
    return post(path, JSON.stringify(data), "application/json; charset=utf-8", "json")
}

function get(path) {
    var headers = getDefaultHeaders()
    return new Promise(function(resolve, reject) {
        HTTP.get(
            path,
            {headers}
        ).then(response => {
            // get body data
            resolve(response.data)
        })
        .catch(error => {
            // error callback
            handleApiFailure(error, reject)
        })
    })
}

function put(path) {
    var headers = getDefaultHeaders()
    return new Promise(function(resolve, reject) {
        HTTP.put(
            path,
            {headers}
        ).then(response => {
            // get body data
            resolve(response.data)
        })
        .catch(error => {
            // error callback
            handleApiFailure(error, reject)
        })
    })
}

function del(path) {
    var headers = getDefaultHeaders()
    return new Promise(function(resolve, reject) {
        HTTP.delete(
            path,
            {headers}
        ).then(response => {
            // get body data
            resolve(response.data)
        })
        .catch(error => {
            // error callback
            handleApiFailure(error, reject)
        })
    })
}

function post(path, data, contentType) {
    var headers = getDefaultHeaders()
    if (contentType) {
        headers['Content-Type'] = contentType
    }
    return new Promise(function(resolve, reject) {
        HTTP.post(
            path,
            data,
            {headers}
        ).then(response => {
            // get body data
            resolve(response.data)
        })
        .catch(error => {
            // error callback
            handleApiFailure(error, reject)
        })
    })
}

function put(path, data, contentType) {
    var headers = getDefaultHeaders()
    if (contentType) {
        headers['Content-Type'] = contentType
    }
    return new Promise(function(resolve, reject) {
        HTTP.put(
            path,
            data,
            {headers}
        ).then(response => {
            // get body data
            resolve(response.data)
        })
        .catch(error => {
            // error callback
            handleApiFailure(error, reject)
        })
    })
}

function handleApiResponse(error, response, resolve, reject) {
    // console.log(response)
    if (error) {
        handleApiFailure(error, reject)
    } else {
        if (response.data) {
            handleApiSuccess(response.data, resolve, reject)
        } else {
            handleApiSuccess(response.text, resolve, reject)
        }
    }
}

function handleApiSuccess(response, resolve, reject) {
    resolve(response)
}

function handleApiFailure(error, reject) {
    console.error("API Error")
    console.error(error.response.data.error)
    if (error.response && error.response.data && error.response.data.error) {
        reject(error.response.data.error)
    } else if (error.code == "ECONNABORTED") {
        reject("Can't reach server")
    } else {
        reject()
    }

}

function getDefaultHeaders() {
    var headers = {}
    if (store.state.user.jwt) {
        headers['Authorization'] = 'Bearer ' + store.state.user.jwt
    }
    headers['Accept'] = 'application/vnd.youtv.v9+json'
    headers['Device-Uuid'] = store.state.uuid

    return headers
}